import API from 'services/TAPS_API';

export default function getSkvpzuList() {
  return API.request({
    method: 'GET',
    url: `/dictionary/code-skvpzu`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
